import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RtsWelcomeBannerComponent } from './rts-welcome-banner.component';
import { GtmModule } from '../../../directives/gtm/gtm.module';
import { DlsIconModule } from '@zelis/dls/icons';
import { DlsButtonModule } from '@zelis/dls/button';

@NgModule({
  declarations: [RtsWelcomeBannerComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FlexLayoutModule,
    GtmModule,
    DlsIconModule,
    DlsButtonModule,
  ],
  providers: [],
  exports: [RtsWelcomeBannerComponent],
})
export class RtsWelcomeBannerModule {}
